import { Users } from 'lucide-react';

import { ChannelSourcePage } from '../components/ChannelSourcePage';

export function LinkedInAnalyticsPage() {
  return (
    <ChannelSourcePage
      source="linkedin"
      title="LinkedIn"
      description="Lead inflow from LinkedIn. Profile analytics are added when the integration is connected."
      icon={Users}
      integrationKey="linkedin"
    />
  );
}
